const ADD_TO_WATCHLIST = 'addToWatchlist'; // custom event
const REMOVE_FROM_WATCHLIST = 'removeFromWatchlist'; // custom event
const WATCHLIST_HAS_NOTIFICATION = 'watchListHasNotification'; // watchlist flag in localStorage

export { ADD_TO_WATCHLIST, REMOVE_FROM_WATCHLIST, WATCHLIST_HAS_NOTIFICATION };
